import React from 'react'

export function EditIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 40 40"
    >
      {/* <circle cx="20" cy="20" r="19.5" fill="#fff" stroke="#E0E0E0" /> */}
      <path
        fill="#43D0A3"
        fillRule="evenodd"
        d="M25.205 18.796L27 17c.545-.545.818-.818.963-1.112a2 2 0 000-1.776c-.145-.294-.418-.567-.963-1.112-.546-.545-.818-.818-1.112-.964a2 2 0 00-1.776 0c-.294.146-.567.419-1.112.964l-1.819 1.819a10.9 10.9 0 004.023 3.977zm-5.477-2.523l-6.87 6.87c-.426.426-.639.638-.778.9-.14.26-.199.555-.317 1.145l-.615 3.077c-.067.332-.1.498-.005.593.094.095.26.061.593-.005l3.077-.616c.59-.117.884-.176 1.145-.316s.474-.352.9-.777l6.889-6.89a12.903 12.903 0 01-4.02-3.98z"
        clipRule="evenodd"
      />
    </svg>
  )
}
